var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPkrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5360_11574)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5360_11574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5118 13.9324H4.17688V2.06702H17.5119C17.5889 2.06702 17.6515 2.12954 17.6515 2.20662V13.7928C17.6515 13.7928 17.6515 13.7928 17.6515 13.7928C17.6514 13.8699 17.5889 13.9324 17.5118 13.9324Z",
    fill: "#496E2D",
    stroke: "#3A3D5A",
    strokeWidth: 0.364512
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95733 14.0769H-0.510666C-0.667558 14.0769 -0.794782 13.9497 -0.794782 13.7928V2.20662C-0.794782 2.04973 -0.667558 1.9225 -0.510666 1.9225H3.95733V14.0769Z",
    fill: "#F5F5F5",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754748
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2153 9.71232L14.2153 9.71233L14.216 9.71166L14.2168 9.71099L14.2174 9.7104C14.2183 9.70958 14.219 9.70931 14.2192 9.70922L14.2198 9.70911C14.2201 9.70911 14.2211 9.70929 14.2223 9.71019C14.2235 9.71109 14.2238 9.71198 14.2239 9.71226L14.2239 9.7127C14.2239 9.71291 14.2238 9.71365 14.2231 9.71493C13.5709 10.9386 12.2873 11.7719 10.8062 11.7719C8.66509 11.7719 6.92934 10.0337 6.92934 7.88722C6.92934 6.23951 7.95506 4.83219 9.40192 4.26876C9.40325 4.26824 9.40398 4.26821 9.40419 4.26821L9.40461 4.26827C9.40489 4.26838 9.40575 4.26887 9.40652 4.27014C9.40729 4.27141 9.40734 4.27242 9.4073 4.27276L9.40715 4.27322C9.40704 4.27341 9.40668 4.27405 9.40562 4.27498C9.40562 4.27498 9.40561 4.27499 9.4056 4.27499L9.39904 4.28078L9.39893 4.28088C7.90206 5.61429 7.76761 7.9124 9.0959 9.40924C10.4267 10.9088 12.7183 11.0459 14.2153 9.71232Z",
    fill: "#F5F5F5",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754748
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2567 4.9841L12.2567 4.9841L12.7714 5.56163L12.7894 5.58177L12.8143 5.57131L13.5274 5.27118L13.5274 5.27118C13.5863 5.24638 13.6428 5.31085 13.6106 5.366L13.6106 5.36601L13.2204 6.03411L13.2068 6.0574L13.2244 6.07781L13.7302 6.66326C13.772 6.71162 13.7281 6.78532 13.6657 6.77172L13.6657 6.77172L12.9098 6.60707L12.8834 6.60133L12.8695 6.62441L12.4689 7.28634C12.4359 7.34099 12.3522 7.32213 12.3458 7.25852C12.3458 7.25852 12.3458 7.25852 12.3458 7.25851L12.2688 6.48867L12.2661 6.46183L12.2399 6.45568L11.4866 6.2793C11.4243 6.2647 11.4165 6.17934 11.475 6.15364L12.1834 5.84255L12.2081 5.8317L12.2058 5.80482L12.1408 5.03391L12.1408 5.03391C12.1354 4.97029 12.2142 4.93641 12.2567 4.9841Z",
    fill: "#F5F5F5",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754748
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5360_11574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5360_11574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white",
    transform: "translate(0.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkrFlag);
export default __webpack_public_path__ + "static/media/Pkr-flag.e46bfd6c456a8fd2ef227a82132de56b.svg";
export { ForwardRef as ReactComponent };